export const actionTypes = {
  DISPLAY_DIALOG: 'DISPLAY_DIALOG',
};

export const displayDialog = ({ limitedFeature, notificationDialog }) => ({
  type: actionTypes.DISPLAY_DIALOG,
  limitedFeature,
  notificationDialog,
});
